import AppPage from "@/components/AppPage.vue";
import CardLayout0 from "@/components/CardLayouts/CardLayout0.vue";
import CardLayout1 from "@/components/CardLayouts/CardLayout1.vue";
import AgentInfoCard from "@/components/Cards/Model/AgentInfoCard.vue";
import InstallationCard from "@/components/Cards/Model/InstallationCard.vue";
import MachineCard from "@/components/Cards/Model/MachineCard.vue";
import MachineStatusCard from "@/components/Cards/Model/MachineStatusCard.vue";
import DateMomentTooltip from "@/components/DateMomentTooltip.vue";
import DebugShowObject from "@/components/DebugShowObject.vue";
import FrameCard from "@/components/FrameCard.vue";
import TableTopScrollbar from "@/components/TableTopScrollbar.vue";
import TagChip from "@/components/TagChip.vue";
import VFaIcon from "@/components/VFaIcon.vue";
import GenericDetailsCard from "@/views/App/Components/GenericDetailsCard.vue";
import VueApexCharts from "vue-apexcharts";

// export
export default {
    install(Vue) {
        Vue.component("app-page", AppPage);
        Vue.component("VFaIcon", VFaIcon);
        Vue.component("debug-show-object", DebugShowObject);
        Vue.component("date-moment-tooltip", DateMomentTooltip);
        Vue.component("frame-card", FrameCard);
        Vue.component("generic-details-card", GenericDetailsCard);
        Vue.component("card-layout-0", CardLayout0);
        Vue.component("card-layout-1", CardLayout1);
        Vue.component("agent-info-card", AgentInfoCard);
        Vue.component("installation-card", InstallationCard);
        Vue.component("machine-card", MachineCard);
        Vue.component("machine-status-card", MachineStatusCard);
        Vue.component("apexchart", VueApexCharts);
        Vue.component("TagChip", TagChip);
        Vue.component("TableTopScrollbar", TableTopScrollbar);
    },
};
